import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable5 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';

const Table5Report = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [buttonAccess, setButtonAccess] = useState({
      userLevel: "",
      roles: "",
      isVisible: false,
    });
  
    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const navigate = useNavigate();
    const config = getAuthHeaders();
  
  
    const storedLanguage = localStorage.getItem('language');
  
    //get next Years 
    const getNextYear = (year) => {
      const nextYear = parseInt(year) + 1;
      const nextYearShort = nextYear.toString().slice(-2);
      return `${year}-${nextYearShort}`;
    };
  
    //get Years 
    const getAllYears = () => {
      // const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = new Date().getFullYear() - 2; year >= 2013; year--) {
        yearsArray.push(year);
      }
      return yearsArray;
    };
  
  
    useEffect(() => {
      const level = handleUserLevelAccessPermissions(decode_token);
      setButtonAccess(level);
      setYears(getAllYears());
    }, []);
  
  
  
    const handleDropdownChange = (e) => {
      setYearName(e.target.value);
    };
  
    const downloadStaticTable5Xlsx = async () => {
      const fileUrl = `pdf/ASI_Table5.xlsx`;
      try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
          throw new Error("File not found");
        }
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = "ASI_Table5.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      } catch (error) {
        console.error(error);
        toast.error("File not found", messages.COLOR_RED);
      } finally {
        showLoading(false);
      }
    };
    const handleGenerateExcel = () => {
      if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
      }
  
      showLoading(true);
      // Prepare payload
      const payload = {
        survey_year: yearName,
      };
      if (String(yearName) === "2023") {
        downloadStaticTable5Xlsx();
        return false;
      }
      // POST request to API
      axios
          .post(`${API_URL}api/asi/reports/HQReports/asigetTable5Report`, payload, config)
          .then((response) => {
            const table5Report = response.data.data.asiTable5Report;

            if (!table5Report || table5Report.length === 0) {
              toast.info("Data not found");
              showLoading(false);
              return;
            }
    
            let excelFileName = 'ASI_Table5';
            const excelObjectData = {
              fileName: excelFileName,
              reportType: excelFileName,
              fileType: 'xls',
              sheetName: "ASI_Table5",
              firstRowMergeCells: "A1:I1",
              firstRowExportData: 'सारिणी -५',
              firstRowCellNumber: 11,
              secondRowMergeCells: "A2:I2",
              secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}-${parseInt(yearName) + 1}`,
              thirdRowMergeCells: "A3:I3",
              thirdRowText: 'उत्तर प्रदेश के उद्योगों में उपभुक्त ईंधन',
              headerHindiColumns: [],
            };
    
            const transformedData = table5Report.map(item => [
              item.NIC_CODE_PERFRAME,
              item.COALAMOUNT,
            //   item.NIC_CODE_PERFRAME === null ? 'null' : item.NIC_CODE_PERFRAME,
              item.COALPRICE,
              item.ELECTRICITYPURCHASINGQUANTITY,
              item.ELECTRICITYPURCHASEPRICE,
              item.PETROLEUMPRODUCT,
              item.GAS,
              item.OTHERFUEL,
              item.TOTALVALUE,
            ]);

            excelObjectData.excelRowData = transformedData;
    
            generateExcelASITable5(excelObjectData);
    
            showLoading(false);
          })
          .catch((error) => {
            console.error('API Error:', error);
            showLoading(false);
          });
      };
    
    return (
      <>
        <GlobalLoading />
        <ToastContainer />
        <div className="container-fluid py-3">
          <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
              <div className="row align-items-center">
                <h4 className="page_heading">
                  <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_FIVE_REPORT : asiTitle.en.TABLE_FIVE_REPORT }} />
                </h4>
                <div className="row align-items-center">
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">
                    {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                      </label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleDropdownChange}
                      value={yearName}
                    >
                      <option value="" disabled>
                        Select Year
                      </option>
                      {years 
                        .sort((a, b) => b - a) 
                        .map((yearName, index) => (
                          <option key={index} value={yearName}>
                            {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-xl-2 col-lg-12 mb-3">
                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

export default Table5Report